import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLink: false,
    menuData: [],
    token: null,
    curMenu: '',
    //左侧菜单是否显示
    leftMenuVisible: undefined,
    //左侧菜单的父菜单ID
    leftMenuPID: "",
    //当前选中的左侧菜单
    curLeftMenu: "",
    //iframe嵌套三方页面时，iframe 的src地址，这里用来跨页面传值，防止src显示到浏览器的url中
    iframeLayoutSrc: "",
    //当前路由页面中需要加载的数据是哪个站点类型，作为查询参数,暂时只存在查询一种类型的站点情况
    curStationType:''
  },
  getters: {
    getCurMenu: state => {
      if (!state.curMenu) {
        return window.sessionStorage.getItem("curMenu");
      } else {
        return state.curMenu;
      }
    },
    getIframeLayoutSrc: state => {
      if (state.iframeLayoutSrc) {
        return state.iframeLayoutSrc;
      }
      else {
        return window.sessionStorage.getItem("iframeLayoutSrc");
      }

    }
   
  },
  mutations: {
    saveIsLink(state, data) {
      state.isLink = data;
    },
    saveToken(state, data) {
      state.token = data;
      window.localStorage.setItem("Token", data);
    },
    saveMenuData(state, data) {
      state.menuData = data;
    },
    setCurMenu(state, data) {
      state.curMenu = data;
      window.sessionStorage.setItem("curMenu", data);
    },
    saveLeftMenuVisible(state, data) {
      state.leftMenuVisible = data;
    
    },
    saveLeftMenuPID(state, data) {
      state.leftMenuPID = data;
     
    },
    saveCurLeftMenu(state, data) {
      state.CurLeftMenu = data;
      window.sessionStorage.setItem("curLeftMenu", data);
    },
    saveIframeLayoutSrc(state, data) {
      state.iframeLayoutSrc = data;
      window.sessionStorage.setItem("iframeLayoutSrc", data);
    },
    saveCurStationType(state,data){
      state.curStationType=data;
    },
  },
  actions: {
  },
  modules: {
  }
})
